import React, { Fragment } from 'react';
import _ from 'lodash';
import { Row, Col, OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import * as commonActionType from '@common/store/common/common.actionsType';
import Field from '@common/components/validation/field.validation';
import PubSub from 'pubsub-js';
import autoBind from 'react-autobind';
import sessionUtil from '@common/helpers/sessionStorage.utils';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import Clear from '@material-ui/icons/Clear';
import commonMessages from '@common/constraints/common.messages';
import { Tooltip } from '@material-ui/core';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);

    this.isExterno = sessionUtil.getItem('isExterno');
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.RESET, this.clear.bind(this));
  }

  clear() {
    if (this.inputFile) this.inputFile.value = '';
    if (this.inputImg) this.inputImg.src = '';
    if (this.inputText) this.inputText.value = '';
  }

  onChange(onChange) {
    return (e) => {
      let file = e.target.files[0];
      let filename = file.name;
      let extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
      let newFileName = undefined;

      let errorMessage = this.validateOnChange(filename, extension);
      if (errorMessage) {
        this.clear();
        _alert.warning(errorMessage);
        return;
      }

      if (this.props.newFileName) {
        let newFileName = `${this.props.newFileName}.${extension}`;
        var new_file = new File([file], newFileName, { type: file.type });
        onChange(new_file, false, filename);
      } else onChange(e.target.files[0]);

      if (this.props.TipoFileUpload == 'imagem') {
        let img = this.inputImg;
        var fr = new FileReader();
        fr.onload = function () {
          img.src = fr.result;
        };
        fr.readAsDataURL(e.target.files[0]);
      } else if (this.props.TipoFileUpload == 'file') {
        if (!newFileName) this.inputText.value = e.target.files[0].name;
        else this.inputText.value = newFileName;
      }
    };
  }

  loadFile() {
    this.inputFile.click();
  }

  validateOnChange(filename, extension) {
    const { extensionsAllowed, TamanhoNomeArquivo, TamanhoMaximoArquivo } = this.props;

    if (extensionsAllowed) {
      var allowed = extensionsAllowed
        .split('|')
        .find((extensionAllowed) => extensionAllowed.toLowerCase() === extension.toLowerCase());

      if (!allowed) return commonMessages.validations.EXTENSION_FILE_INVALID;
    }

    //Valor de TamanhoMaximoArquivo deve estar em MB
    if (TamanhoMaximoArquivo) {
      //Convertendo para bytes
      var tamanhoMaximoBytes = TamanhoMaximoArquivo * 1024 * 1024;
      var input = this.inputFile || this.inputImg;
      if (input.files) {
        for (var i = 0; i < input.files.length; i++) {
          var file = input.files.item(i);
          if (file.size > tamanhoMaximoBytes) return commonMessages.validations.MAX_LENGTH_FILE(TamanhoMaximoArquivo);
        }
      }
    }

    if (TamanhoNomeArquivo && filename && filename.length > TamanhoNomeArquivo)
      return commonMessages.validations.MAX_LENGTH_NAME_FILE(TamanhoNomeArquivo);
  }

  validate() {
    const { extensionsAllowed, state, TamanhoNomeArquivo, TamanhoMaximoArquivo } = this.props;
    const NomeArquivo = state ? state.NomeArquivo : undefined;

    if (extensionsAllowed) {
      var input = this.inputFile || this.inputImg;

      if (input && input.value) {
        var extensionInput = /^.+\.([^.]+)$/.exec(input.value.toLowerCase());
        var extension = extensionInput == null ? '' : extensionInput[1];

        var allowed = extensionsAllowed.split('|').find((extensionAllowed) => extensionAllowed === extension);

        if (!allowed) return commonMessages.validations.MAX_LENGTH_FILE(TamanhoMaximoArquivo);
      }
    }

    //Valor de TamanhoMaximoArquivo deve estar em MB
    if (TamanhoMaximoArquivo) {
      //Convertendo para bytes
      var tamanhoMaximoBytes = TamanhoMaximoArquivo * 1024 * 1024;
      var input = this.inputFile || this.inputImg;
      if (input.files) {
        for (var i = 0; i < input.files.length; i++) {
          var file = input.files.item(i);
          if (file.size > tamanhoMaximoBytes) return commonMessages.validations.MAX_LENGTH_FILE;
        }
      }
    }

    if (TamanhoNomeArquivo && NomeArquivo && NomeArquivo.length > TamanhoNomeArquivo)
      return commonMessages.validations.MAX_LENGTH_NAME_FILE(TamanhoNomeArquivo);
  }

  async downloadFile(service, caminho) {
    await service(caminho);
  }

  async downloadFileViewInBrowser(service, caminho) {
    await service(caminho);
  }

  removeFile(onChange) {
    return (e) => {
      this.inputFile.value = '';
      if (this.inputImg) this.inputImg.src = '';
      if (this.inputText) this.inputText.value = '';
      onChange('');
    };
  }

  actionButtons(onChange, value) {
    const { onDelete, service, prefix, Caminho, name, PlacementTooltip } = this.props;

    if (this.isExterno) {
      return (
        <Fragment>
          {Caminho && prefix != 'I' && (
            <Tooltip title="Download Arquivo">
              <Button
                variant="contained"
                color="primary"
                className="mr-2"
                onClick={() => this.downloadFile(service, Caminho)}
              >
                <i className="fas fa-file-download mr-2" />
              </Button>
            </Tooltip>
          )}

          {prefix != 'V' && (
            <Fragment>
              <Tooltip title="Anexar Arquivo">
                <Button
                  variant="contained"
                  color="primary"
                  className="mr-2 button-file"
                  onClick={this.loadFile}
                  tooltip={'Anexo'}
                >
                  <i className="fa fa-paperclip" />
                </Button>
              </Tooltip>
              <Tooltip title="Cancelar Anexo">
                <Button
                  className="mr-2 button-file"
                  style={{ padding: 0 }}
                  variant="contained"
                  color="default"
                  onClick={this.removeFile(onChange)}
                >
                  <Clear />
                </Button>
              </Tooltip>
            </Fragment>
          )}

          {onDelete && prefix != 'V' && (
            <Tooltip title="Deletar Anexo">
              <Button
                className="mr-2"
                style={({ height: 25 }, { padding: 0 })}
                variant="contained"
                color="default"
                onClick={() => onDelete()}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          )}
        </Fragment>
      );
    } else {
      return (
        <div className="d-inline-block">
          {Caminho && prefix != 'I' && (
            <OverlayTrigger
              key={`top-download-${name}`}
              placement={PlacementTooltip || 'top'}
              overlay={
                <TooltipBootstrap id={`tooltip-downloadArquivo`}>
                  <div className={'fontTooltip'}>Download Arquivo</div>
                </TooltipBootstrap>
              }
            >
              <button
                type="button"
                tooltip="Download Arquivo"
                className="btn btn-primary mr-2"
                onClick={() => this.downloadFile(service, Caminho)}
              >
                <i className="fas fa-file-download" />
              </button>
              </OverlayTrigger>
          )}
          {prefix != 'V' && (
            <Fragment>
              <OverlayTrigger
                key={`top-anexar-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-anexoArquivo`}>
                    <div className={'fontTooltip'}>Anexar Arquivo</div>
                  </TooltipBootstrap>
                }
              >
                <button
                  type="button" 
                  tooltip="Anexar Arquivo" 
                  className="btn btn-primary mr-2" 
                  onClick={this.loadFile}>
                  <i className="fa fa-paperclip" />
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                key={`top-deletar-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-deletarArquivo`}>
                    <div className={'fontTooltip'}>Deletar Arquivo</div>
                  </TooltipBootstrap>
                }
              >
                <button
                  type="button"
                  tooltip="Deletar Anexo"
                  className="btn btn-primary mr-2"
                  onClick={this.removeFile(onChange)}
                >
                  <i className="fa fa-eraser" />
                </button>
              </OverlayTrigger>
            </Fragment>
          )}

          {onDelete && prefix != 'V' && (
            <OverlayTrigger
              key={`top-${name}`}
              placement={PlacementTooltip || 'top'}
              overlay={
                <TooltipBootstrap id={`tooltip-cancelarArquivo`}>
                  <div className={'fontTooltip'}>Cancelar Arquivo</div>
                </TooltipBootstrap>
              }
            >
              <button type="button" tooltip="Cancelar Anexo" className="btn btn-cancel" onClick={() => onDelete()}>
                <i className="fas fa-times" />
              </button>
            </OverlayTrigger>
          )}
        </div>
      );
    }
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Placeholder,
      TipoFileUpload,
      extensionsAllowed,
      name,
      newFileName,
      PlacementTooltip,
    } = props;
    const hasTipoImage = TipoFileUpload == 'imagem';
    const hasTipoFile = TipoFileUpload == 'file';

    const extensionAllowedFormated = extensionsAllowed ? '.' + extensionsAllowed.split('|').join(', .') : '';

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChange, onChangeFile }) => {
          return (
            <LabeledInput {...props}>
              <input
                type="file"
                accept={extensionAllowedFormated}
                style={{ display: 'none' }}
                onChange={this.onChange(!newFileName ? onChange : onChangeFile)}
                ref={(inputFile) => (this.inputFile = inputFile)}
              />
              {hasTipoImage && (
                <div>
                  <div
                    style={{
                      textAlign: 'center',
                      height: '240px',
                      width: '350px',
                      backgroundColor: '#AAA',
                      display: 'flex',
                    }}
                  >
                    <img
                      src={value}
                      ref={(inputImg) => (this.inputImg = inputImg)}
                      style={{
                        display: 'block',
                        margin: 'auto',
                        maxWidth: '350px',
                        maxHeight: '240px',
                      }}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: '5px',
                      width: '350px',
                      textAlign: 'right',
                    }}
                  >
                    {this.actionButtons(onChange, value)}
                  </div>
                </div>
              )}
              {hasTipoFile && (
                <Row>
                  <Col>
                    <OverlayTrigger
                      key={`top-${name}`}
                      placement={PlacementTooltip || 'top'}
                      overlay={
                        <TooltipBootstrap id={`tooltip-${name}`}>
                          <div className={'fontTooltip'}>{Tooltip || Label} </div>
                        </TooltipBootstrap>
                      }
                    >
                      <input
                        className={`form-control ${hasError ? 'form-invalid' : ''}`}
                        type="text"
                        disabled={true}
                        value={value ? value.name || value : ''}
                        required={Obrigatorio}
                        placeholder={Placeholder || Label}
                        ref={(inputText) => (this.inputText = inputText)}
                      />
                    </OverlayTrigger>
                  </Col>
                  <div>{this.actionButtons(onChange, value)}</div>
                </Row>
              )}
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    const { props } = this;
    const { TipoFileUpload } = props;
    const hasTipoImage = TipoFileUpload == 'imagem';
    const hasTipoFile = TipoFileUpload == 'file';
    return (
      <Field {...this.props}>
        {({ value, onChange }) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              {hasTipoImage && (
                <div
                  style={{
                    textAlign: 'center',
                    height: '240px',
                    width: '350px',
                    backgroundColor: '#AAA',
                    display: 'flex',
                  }}
                >
                  <img
                    ref={(inputImg) => (this.inputImg = inputImg)}
                    src={value}
                    style={{
                      display: 'block',
                      margin: 'auto',
                      maxWidth: '350px',
                      maxHeight: '240px',
                    }}
                  />
                </div>
              )}

              {hasTipoFile && (
                <Row>
                  <Col>
                    <label className="form-control">{value ? value.name || value : ''}</label>
                  </Col>
                  <Col>{this.actionButtons(onChange, value)}</Col>
                </Row>
              )}
            </LabeledInput>
          );
        }}
      </Field>
    );
  }
}

export default DDadosComponent;
